import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import './index.css';
import api from '../../services/api_adiantamento';

export default function Menu(props) {

    const [logEmpresa, setLogEmpresa] = useState({});

    let history = useHistory();

    useEffect(() => {
        window.addEventListener("storage", () => {
            history.push('/home');
            window.location.reload(false);
        });

        api.get(`/empresa/find`).then(function (response) {
            if (response.data) {
                setLogEmpresa(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, []);

    useEffect(() => {
        if(logEmpresa.id) {
            document.getElementById('footer_empresa').innerHTML = `Empresa logada: ${logEmpresa.descempresa}`;
        } else {
            document.getElementById('footer_empresa').innerHTML = '';
        }
    }, [logEmpresa]);

    function handleBack(event) {
        event.preventDefault();

        if(history.location.pathname !== '/home') {
            window.history.back();
        }
    }

    function handleInicio(event) {
        event.preventDefault();
        history.push('/home');
    }

    function handleLogout(event) {
        setLogEmpresa({});
        event.preventDefault();
        history.push('/logout');
    }

    function handleTrocaSenha(event) {
        event.preventDefault();
        history.push('/trocasenha');
    }

    function handleAuditar(event) {
        event.preventDefault();
        history.push('/auditoria');
    }

    function handleTrocaEmp(event) {
        event.preventDefault();
        history.push('/empresas');
    }

    var url_atual = window.location.href;


    return (
        <div className={(!url_atual.includes('dashboard/') ? "container-lg" : 'none')}>
            {/* <div className="empresa">
                Empresa logada: {logEmpresa.descempresa}
            </div> */}
            <div>
                <nav id="menu">
                    <ul>
                        <li key="1"><a href="#" onClick={handleBack}><span className="lnr lnr-arrow-left-circle">Voltar</span></a></li>
                        <li key="2"><a href="#" onClick={handleInicio}><span className="lnr lnr-home">Inicio</span></a></li>
                        <li key="3"><a href="#" onClick={handleTrocaEmp}><span className="lnr lnr-exit">Trocar Empresa</span></a></li>
                        <li key="4"><a href="#" onClick={handleTrocaSenha}><span className="lnr lnr-lock">Trocar senha</span></a></li>
                        <li key="5"><a href="#" onClick={handleAuditar}><span className="lnr lnr-exit">Auditar Conexão</span></a></li>
                        <li key="6"><a href="#" onClick={handleLogout}><span className="lnr lnr-exit">Sair</span></a></li>
                    </ul>
                </nav>
            </div>
        </div>
    )


}